/*
 * Homepage hero gallery: fades between hero slides, numbered controls, auto-rotate.
 * Markup: sections/gbg-hero-slider.liquid. Slide look comes from gbg-hero.css (same as every hero).
 */
(function () {
  'use strict';

  function init(root) {
    if (root.__gbgSliderReady) return;
    root.__gbgSliderReady = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gbg-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gbg-slide-dot]'));
    if (slides.length < 2) return;

    var speed = (parseFloat(root.getAttribute('data-speed')) || 5) * 1000;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var paused = false;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      dots.forEach(function (d, n) {
        if (n === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!autoplay || reduce || paused) return;
      timer = setInterval(function () { show(index + 1); }, speed);
    }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { show(n); start(); });
    });

    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 50) { show(index + (dx < 0 ? 1 : -1)); start(); }
    }, { passive: true });

    // Theme editor: jump to the slide being edited and stop rotating.
    root.addEventListener('shopify:block:select', function (e) {
      var n = slides.indexOf(e.target);
      if (n > -1) { autoplay = false; stop(); show(n); }
    });
    root.addEventListener('shopify:block:deselect', function () {
      autoplay = root.getAttribute('data-autoplay') === 'true';
      start();
    });

    show(0);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-gbg-hero-slider]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
